import {Component, inject, OnInit} from '@angular/core'
import {MatButton} from '@angular/material/button'
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogTitle
} from '@angular/material/dialog'
import {Kalpylator} from '@sparbanken-syd/kalpylator'
import {LoansComponent} from '../92-loans/loans.component'
import {PropertiesComponent} from '../93-properties/properties.component'
import {ApplicantsComponent} from '../94-applicants/applicants.component'
import {MatCard, MatCardContent, MatCardHeader, MatCardTitle} from '@angular/material/card'

@Component({
  selector: 'spb-detail-dialog',
  templateUrl: './detail-dialog.component.html',
  styleUrls: ['./detail-dialog.component.scss'],
  imports: [
    MatDialogTitle,
    MatDialogContent,
    ApplicantsComponent,
    LoansComponent,
    PropertiesComponent,
    MatDialogActions,
    MatButton,
    MatDialogClose,
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatCardContent
  ]
})
export class DetailDialogComponent implements OnInit {
  public kalpylator: Kalpylator = new Kalpylator()

  private readonly data = inject(MAT_DIALOG_DATA)

  ngOnInit(): void {
    this.kalpylator = this.data.kalpylator
  }
}
